import type {
  OpencodeMessage,
  OpencodeMessagePart,
  OpencodePersistenceEvent,
  OpencodeUpstreamMessage,
  OpencodeUpstreamPart,
} from "schemas/generated/opencode";

import { unixTimestampToDateOrNull } from "replo-utils/lib/datetime";

import {
  opencodePartDataSchema,
  opencodePersistenceEventSchema,
} from "../opencode";

type OpencodePersistenceEventType = OpencodePersistenceEvent["type"];

export const opencodePersistenceEventTypes =
  new Set<OpencodePersistenceEventType>(
    opencodePersistenceEventSchema.options.map(
      (option) => option.shape.type.value,
    ),
  );

export function isPersistenceEventType(
  value: string,
): value is OpencodePersistenceEventType {
  return opencodePersistenceEventTypes.has(
    value as OpencodePersistenceEventType,
  );
}

export function transformUpstreamToOpencodeMessage({
  upstreamMessage,
  userId,
  opencodeSessionUuid,
}: {
  upstreamMessage: OpencodeUpstreamMessage;
  userId: string;
  opencodeSessionUuid: string;
}): OpencodeMessage {
  const now = new Date();

  return {
    id: crypto.randomUUID(),
    userId,
    opencodeSessionUuid,
    createdAt: now,
    updatedAt: now,
    deletedAt: null,
    opencodeId: upstreamMessage.id,
    opencodeSessionId: upstreamMessage.sessionID,
    opencodeParentId: upstreamMessage.parentID ?? null,
    completedAt: unixTimestampToDateOrNull({
      value: upstreamMessage.time.completed,
    }),
    role: upstreamMessage.role,
    finishReason: upstreamMessage.finish ?? null,
    error: upstreamMessage.error ?? null,
    cost: upstreamMessage.cost ?? null,
    tokensInput: upstreamMessage.tokens?.input ?? null,
    tokensOutput: upstreamMessage.tokens?.output ?? null,
    tokensReasoning: upstreamMessage.tokens?.reasoning ?? null,
  };
}

export function transformUpstreamToOpencodeMessagePart({
  upstreamPart,
  opencodeMessageUuid,
}: {
  upstreamPart: OpencodeUpstreamPart;
  opencodeMessageUuid: string;
}): OpencodeMessagePart {
  const parsedPartData = opencodePartDataSchema.parse(upstreamPart);
  const now = new Date();

  return {
    id: crypto.randomUUID(),
    opencodeMessageUuid,
    opencodeId: parsedPartData.id,
    createdAt: now,
    updatedAt: now,
    deletedAt: null,
    partData: parsedPartData,
  };
}
